import {
  convertStore,
  findCommandsInActions,
  findNavigationRouteInActions,
  timeFromTimeString,
} from '@nextforce/api'
import { isNil } from 'lodash'
import { NonAvailability, StoreUserNonAvailability } from '../types'
import { StoreUserNonAvailabilityResponse } from './response'

export function convertStoreUserNonAvailability(
  response: StoreUserNonAvailabilityResponse.StoreUserNonAvailability
): StoreUserNonAvailability {
  if (isNil(response)) {
    return {} as StoreUserNonAvailability
  }
  return {
    id: String(response?.id),
    user: {
      id: String(response?.user?.id),
      firstName: response?.user?.first_name,
      lastName: response?.user?.last_name,
      photoUrl: response?.user?.avatar_url,
      initials: response?.user?.initials,
    },
    approver: {
      id: String(response?.approver?.id),
      firstName: response?.approver?.first_name,
      lastName: response?.approver?.last_name,
      photoUrl: response?.approver?.avatar_url,
    },
    store: response.store ? convertStore(response.store) : undefined,
    nonAvailability: convertNonAvailability(response?.non_availability),
    status: response.status ? getStatus(response.status) : undefined,
    commands: findCommandsInActions(response.actions_v3),
    route: findNavigationRouteInActions(response.actions_v3),
    changedAt: response.changed_at,
  }
}

export function convertStoreUserNonAvailabilityList(
  response: StoreUserNonAvailabilityResponse.NonAvailabilityList
) {
  return {
    title: response.title,
    nonAvailabilityList:
      response.non_availability_list?.map(convertStoreUserNonAvailability) ??
      [],
  }
}

export function convertNonAvailability(
  nonavailabilities:
    | Array<StoreUserNonAvailabilityResponse.NonAvailability>
    | undefined
): Array<NonAvailability> {
  if (!nonavailabilities) {
    return []
  }

  return nonavailabilities.map(nonAvailability => ({
    dow: nonAvailability.dow,
      shiftBlock: {
        name: nonAvailability.shift_block.name,
        startTime: timeFromTimeString(nonAvailability.shift_block.start_time),
        endTime: timeFromTimeString(nonAvailability.shift_block.end_time),
        seq: nonAvailability.shift_block.seq,
        id: nonAvailability.shift_block.id,
        layerId: nonAvailability.shift_block.layer_id,
        layer: nonAvailability.shift_block.layer,
        active: nonAvailability.shift_block.active ?? true,
      },
    }))
}

function getStatus(status: string): StoreUserNonAvailability['status'] {
  return status === 'APPROVED'
    ? 'APPROVED'
    : status === 'PENDING'
    ? 'PENDING'
    : 'REJECTED'
}
